import axios from 'axios';
import useGlobalUrl from './useGlobalUrl';
import { auth0 } from '@/composables/useAuth0Client';
import useAlerts from './useAlerts';
import useSilentAccessToken from './useSilentAccessToken';
import useSecurityKey from './useSecurityKey';

const { getKey } = useSecurityKey();
const key = getKey();
const { rootUrl } = useGlobalUrl();
const { addAlert } = useAlerts();

export async function resetUserMFA() {
  const { getAccessToken } = useSilentAccessToken();
  const { loginWithRedirect } = auth0;
  const token = await getAccessToken();
  if (!token) {
    addAlert('Failed to reset MFA', 'high', 4);
    return false;
  }

  try {
    await axios.post(`${rootUrl}/auth/reset-mfa?key=${key}`, null, { headers: { Authorization: `Bearer ${token}` } });
    await loginWithRedirect();
  } catch (error) {
    console.error(error);
    addAlert('Failed to reset MFA', 'high', 4);
    return false;
  }
}

export async function resetPW() {
  const { getAccessToken } = useSilentAccessToken();
  const token = await getAccessToken();
  if (!token) {
    addAlert('Failed to get password reset link', 'high', 4);
    return false;
  }

  try {
    const response = await axios.post(`${rootUrl}/auth/get-reset-password-link?key=${key}`, null, { headers: { Authorization: `Bearer ${token}` } });
    const resetLink = response.data.resetLink;
    if (resetLink) {
      window.location.href = resetLink;
    } else {
      addAlert('No password reset link received', 'high', 4);
      return false;
    }
  } catch (error) {
    console.error(error);
    addAlert('Failed to get password reset link', 'high', 4);
    return false;
  }
}

export async function resetMFA(userId) {
  const { getAccessToken } = useSilentAccessToken();

  const token = await getAccessToken();
  if (!token) {
    addAlert('Failed to reset MFA', 'high', 4);
    return false;
  }

  try {
    await axios.post(
      `${rootUrl}/auth/reset-user-mfa?key=${key}`,
      { userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    addAlert('MFA reset successfully', 'low', 2);
    return true;
  } catch (error) {
    console.error('Error resetting MFA:', error);
    addAlert('Error resetting MFA', 'high', 4);
    return false;
  }
}

export async function resendWelcomeEmail(userId) {
  const { getAccessToken } = useSilentAccessToken();

  const token = await getAccessToken();
  if (!token) {
    addAlert('Failed to resend welcome email', 'high', 4);
    return false;
  }

  try {
    await axios.post(
      `${rootUrl}/auth/resend-welcome-email?key=${key}`,
      { userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    addAlert('Welcome email resent', 'low', 2);
    return true;
  } catch (error) {
    console.error('Error resending welcome email:', error);
    addAlert('Error resending welcome email', 'high', 4);
    return false;
  }
}

export async function logoutUser() {
  const { logout } = auth0;
  await logout();
}
